<template>
<div  class="m15 p15 br10 bg-f f-t fw" style="overflow: auto;" :style="{height:getsize.height-170+'px'}">
	<div>
		<p class="titinf">基本信息</p>
		<div class="infitem"><p class="lable">姓名</p><p class="inf">{{user.name}}</p></div>
	</div>
	<div class="infitem"><p class="lable">电话</p><p class="inf">{{user.tell}}</p></div>
	<div class="infitem"><p class="lable">性别</p><p class="inf">{{user.card.gender}}</p></div>
	<div class="infitem"><p class="lable">入职日期</p><p class="inf">{{user.stime}}</p></div>
	<div class="infitem"><p class="lable">校区</p><p class="inf">{{sch}}</p></div>
	<div class="infitem"><p class="lable">职务</p><p class="inf">{{job}}</p></div>
	<div class="infitem"><p class="lable">主要科目</p><p class="inf">{{user.sub.nj+user.sub.sub}}</p></div>
	<div class="infitem"><p class="lable">等级</p><p class="inf">{{user.dj.dj1+user.dj.dj2}}</p></div>
	<div class="infitem"><p class="lable">身份证号</p><p class="inf">{{user.card.id}}</p></div>
	<div class="infitem"><p class="lable">民族</p><p class="inf">{{user.card.nation}}</p></div>
	<div class="infitem"><p class="lable">出生日期</p><p class="inf">{{user.card.day}}</p></div>
	<div class="infitem">
		<p class="lable">农历生日</p>
		<p class="inf">{{user.card.cday}}</p>
		<el-button @click="repmycday" type="primary" icon="el-icon-edit" circle size="mini" class="m5"></el-button><!-- el-icon-upload2  el-icon-loading -->
	</div>
	<div class="infitem"><p class="lable">户籍地址</p><p class="inf">{{user.card.add}}</p></div>
	<div class="infitem">
		<p class="lable">现住址</p>
		<p class="inf">{{user.card.nowadd}}</p>
		<el-button @click="repmynowadd" type="primary" icon="el-icon-edit" circle size="mini" class="m5"></el-button>
	</div>
	<div class="mt10">
		<p class="titinf">最高学历</p>
		<div class="infitem"><p class="lable">证件号码</p><p class="inf">{{user.edu.id}}</p></div>
	</div>
	<div class="infitem"><p class="lable">毕业日期</p><p class="inf">{{user.edu.day}}</p></div>
	<div class="infitem"><p class="lable">毕业院校</p><p class="inf">{{user.edu.sch}}</p></div>
	<div class="infitem"><p class="lable">专业</p><p class="inf">{{user.edu.major}}</p></div>
	<div class="infitem"><p class="lable">学历</p><p class="inf">{{user.edu.edu}}</p></div>
	<div class="mt10">
		<p class="titinf">教师资格证</p>
		<div class="infitem"><p class="lable">证件号码</p><p class="inf">{{user.tch.id}}</p></div>
	</div>
	<div class="infitem"><p class="lable">发证日期</p><p class="inf">{{user.tch.day}}</p></div>
	<div class="infitem"><p class="lable">种类</p><p class="inf">{{user.tch.typ}}</p></div>
	<div class="infitem"><p class="lable">任教科目</p><p class="inf">{{user.tch.sub}}</p></div>
	<div class="infitem"><p class="lable">认定机构</p><p class="inf">{{user.tch.inst}}</p></div>
	<el-drawer :title="tit" :visible.sync="show" :destroy-on-close="true" :wrapperClosable="false" :size="400">
		<el-input v-if="tit==='修改农历生日'" class="ipt" v-model="input"></el-input>
		<el-input v-if="tit==='修改现住址'" class="ipt" type="textarea" :rows="2" placeholder="请输入内容" v-model="input"></el-input>
		<el-button style="margin-top: 30px; margin-left: 250px;width: 100px;" type="primary" @click="submit">提交</el-button>
	</el-drawer>
</div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex'
export default{
	name:'myinf',
	data() {
		return {
			user:{card:{},tch:{},edu:{},sch:[],job:[],dj:{},sub:{}},
			show:false,
			tit:"",
			input:""
		}
	},
	computed:{
		...mapGetters(['getsize']),
		...mapGetters('User',["getPagePower"]),
		sch(){
			let str=""
			this.user.sch.forEach((e,i)=>{
				if(i===0){
					str+=e.name
					return
				}
				str+="/"+e.name
			})
			return str
		},
		job(){
			let str=""
			this.user.job.forEach((e,i)=>{
				if(i===0){
					str+=e.name
					return
				}
				str+="/"+e.name
			})
			return str
		}
	},
	methods:{
		...mapMutations('Tabs',['setCache']),
		...mapGetters('Tabs',['getCache']),
		getinf(){
			this.myfun.Loading()
			this.axios.post("data:myinf").then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.user=e
			})
		},
		repmycday(){
			this.tit="修改农历生日"
			this.show=true
		},
		repmynowadd(){
			this.tit="修改现住址"
			this.show=true
		},
		submit(){
			if(this.input===""){
				this.myfun.messageErr("请输入内容")
				return
			}
			let word="cday"
			if(this.tit==="修改现住址"){
				word="nowadr"
			}
			this.myfun.Loading()
			const formdata = new FormData()
			formdata.append("word",word)
			formdata.append("val",this.input)
			this.axios.post("data:repmyinf",formdata).then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.myfun.messageSuc("修改成功")
				if(this.tit==="修改现住址"){
					this.user.card.nowadd=this.input
				}else{
					this.user.card.cday=this.input
				}
				this.input=""
				this.show=false
			})
		}
	},
	created(){
		if(!this.getPagePower("信息管理/我的信息")){
			this.myfun.messageErr(`您没有"我的信息"的权限`)
			this.$router.push("/404")
			return
		} 
		const cache=this.getCache()('myinf')
		if(cache){
			this.user=cache.user
		}else{
			this.getinf()
		}
	},
	beforeDestroy(){
		this.setCache({
			label:'myinf',
			user:this.user,
		})
	}
}
</script>

<style scoped>
.titinf{
	font-size: 18px;
	font-weight: 700;
	line-height: 30px;
	padding-left: 20px;
	margin-bottom: 10px;
	margin-top: 20px;
}
.titinf:first-child{
	margin-top: 0px;
}
.infitem{
	display: flex;
	align-items: flex-start;
	margin-bottom: 15px;
}
.lable{
	width: 100px;
	text-align: right;
	padding: 5px;
	line-height: 25px;
}
.inf{
	background: #eee;
	padding: 5px;
	width: 250px;
	border-radius: 5px;
	line-height: 25px;
	min-height: 25px;
}
.ipt{
	width: 350px;
	margin-left: 20px;
}
</style>
